export default "__VITE_ASSET__4Rc6ZRph__"